import React, { useState } from 'react';
import Box from '@mui/material/Box';
import { StyledAccordionContainer, StyledLeadContainer} from '../../Components/Styled/index';
import { useSelector } from 'react-redux';
import {ACTIVE_STATUS, handleValidateCodevalue, SALES_ORDER_STATUS} from '../../Utility/constant';
import { ChooseProductType } from '../../Components/ChooseProductType';
import { WhoColumns } from '../../Components/WhoColumns';
import TextFiledWithLabel from '../../Components/TextFieldWithLabel';
import AutoCompleteComponent from '../../Components/AutoCompleteComponenet';
import './salesOrder.css';

const SearchSalesOrder = ({handleSelectStatus,handleSelectOwner,entityDetails,handleOnChange,ownerlistdropdown ,customerdropdown }) => {
    const [isVisible , setIsVisible] = useState(false)
    const internationalise = useSelector(state => state?.internationalise?.currentHashMapData)
    const SOStatusData = useSelector(state => state?.lookup?.lookupData)?.find((item) => item?.name == SALES_ORDER_STATUS)?.codes?.filter(item => item?.status == ACTIVE_STATUS)?.sort((a,b) => a?.sequence - b?.sequence);
    const specificRolePermission = useSelector(state => state?.owner?.rolebasedData);

    return (
        <Box className="sales-order-search-fields">
            <StyledLeadContainer>
                <TextFiledWithLabel 
                id="id" 
                label={handleValidateCodevalue(internationalise,'SO_SEARCH_SO_ID')} name="id"
                type = "number"
                handleOnChange={handleOnChange}
                value={entityDetails?.id}
                />
                <TextFiledWithLabel 
                id="leadId" 
                label={handleValidateCodevalue(internationalise,'SO_SEARCH_LEAD_ID')} 
                name="leadId"
                type = "number"
                handleOnChange={handleOnChange}
                value={entityDetails?.leadId}
                />
                                <AutoCompleteComponent
                    isOwner = {true}
                    optionSet = {customerdropdown}
                    value={entityDetails?.selectedCustomer|| null}
                    name = "selectedCustomer"
                    placeholder={handleValidateCodevalue(internationalise,'SO_SEARCH_CUSTOMER')}
                    label={handleValidateCodevalue(internationalise,'SO_SEARCH_CUSTOMER')}
                    onChange={(event, Owner) => handleSelectOwner(event, Owner,"Customer")}
                />
                <ChooseProductType
                    value={entityDetails?.productId || ""}
                    searchState={entityDetails}
                    handleChangeSearchField={handleOnChange} 
                />
            </StyledLeadContainer>
            <StyledAccordionContainer>
                <AutoCompleteComponent
                    multiple
                    className="sales-order-search-autocomplete"
                    limitTags={3}
                    optionSet = {ownerlistdropdown}
                    value={entityDetails?.selectedOwner || []}
                    name = "ownerId"
                    placeholder={handleValidateCodevalue(internationalise,'SO_SEARCH_OWNER')}
                    disabled = {!(specificRolePermission?.isAllOrderManage || specificRolePermission?.isOrderTeamManage)}
                    label={handleValidateCodevalue(internationalise,'SO_SEARCH_OWNER')}
                    onChange={(event, Owner) => handleSelectOwner(event, Owner)}
                />
                
                <AutoCompleteComponent
                    multiple
                    className="sales-order-search-autocomplete"
                    limitTags={3}
                    isLookup = {true}
                    optionSet = {SOStatusData}
                    value={entityDetails?.status || []}
                    name = "ownerId"
                    placeholder={handleValidateCodevalue(internationalise,'SO_STATUS')}
                    label={handleValidateCodevalue(internationalise,'SO_STATUS')}
                    onChange={(event, Status) => handleSelectStatus(event, Status,"status")}
                />
            </StyledAccordionContainer>
            <WhoColumns
            searchState={entityDetails}
            handleOnChange={handleOnChange}
           />
        </Box>
    );
}

export default SearchSalesOrder;
